<script>
import JsonCSV from "vue-json-csv";

export default {
  extends: JsonCSV,
  props: ["data"],
};
</script>
